import React from 'react';
import PropTypes from 'prop-types';
import Title from './Title';
import { Wrapper, CloseIconWrapper, CloseIcon } from './styled';

const Header = ({ onClose }) => (
  <Wrapper>
    <Title />
    <CloseIconWrapper onClick={ onClose }>
      <CloseIcon />
    </CloseIconWrapper>
  </Wrapper>
);

Header.propTypes = {
  onClose: PropTypes.func.isRequired
};

export default Header;
